import { useEffect, useState } from "react";

import { db } from "../../firebase/firebase";

import { collection, getDocs } from "firebase/firestore";
import "../../assets/css/feedbackResponses.css";

function AdminFeedbackResponses(){

    const [feedback,setFeedback]=useState([]);

    useEffect(()=>{

        loadFeedback();

    },[]);

    const loadFeedback=async()=>{

        const list=[];

        const snapshot=await getDocs(collection(db,"feedback"));

        snapshot.forEach(doc=>{

            list.push({

                id:doc.id,

                ...doc.data()

            });

        });

        setFeedback(list);

    };

    return(

        <section className="testimonial-section">

            <h2>

                What Our Clients Say

            </h2>

            <div className="testimonial-grid">

                {

                    feedback.map(item=>(

                        <div
                            className="testimonial-card"
                            key={item.id}
                        >

                            <h3>

                                {"⭐".repeat(item.rating)}

                            </h3>

                            <p>

                                {item.message}

                            </p>

                            <span>

                                — {item.name}

                            </span>

                        </div>

                    ))

                }

            </div>

        </section>

    );

}

export default AdminFeedbackResponses;